import React from 'react';

import Kiiseries from './Kiiseries';
import Featurgene from './Featurgene';
import Clamping from './Clamping';
import Plasticization from './Plasticization';
import Hydraulic from './Hydraulic';


const Genekii = () => {
  return (
    <div>
      <Kiiseries />
      <Featurgene />
      <Clamping />
      <Plasticization />
      <Hydraulic />
    </div>
  );
};

export default Genekii;
